export enum SUSPENSION_REASONS {
  NONE = 0,
  ADMINISTRATIVE = 1,
  TRIAL_EXCEEDED = 2,
  BILLING_PLAN_EXCEEDED = 3,
  PAYMENT_METHOD_SET_TO_BANK_TRANSFER = 4,
  RENEW_TRIAL = 5,
  ACCEPTED_BILLING_PLAN_UPGRADE = 6,
  SHOPIFY_PAYMENT_CONFIRMATION = 7,
  OVERDUE_INVOICES = 8,
  PAID_INVOICE = 9,
  SCHEDULED_DEACTIVATION = 10,
}
